import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenPt = () => {
    return <AddStartpageComToYourHomeScreen languageCode="pt" />
}

export default AddStartpageComToYourHomeScreenPt
